import request from '../../../helpers/request';

const addFlatsGrid = async (values) => {
  const response = await request.put(
    `/FlatsGrid/new_grid`,
    values,
    `При создании шахматки произошла ошибка`
  );

  return response;
};

export default addFlatsGrid;
